import { Text } from '~/components/ui/Text';
import {
	StyledContainer,
	StyledContentContainer,
	StyledIcon,
} from './VehicleProperty.styled';

interface IVehicleProperty extends React.HTMLAttributes<HTMLDivElement> {
	name: string;
	measure: string;
	value: number;
	icon: string;
}

const VehicleProperty = ({
	name,
	measure,
	value,
	icon,
	...props
}: IVehicleProperty) => {
	return (
		<StyledContainer {...props}>
			<StyledIcon className="icon" $src={icon} />
			<StyledContentContainer>
				<Text style={{ fontSize: 14, color: '#ffffff', opacity: 0.25 }}>
					{name}
				</Text>
				<Text style={{ fontSize: 16, color: '#ffffff' }}>
					{value.toLocaleString('ru-RU')}{' '}
					<span style={{ opacity: 0.5 }}>{measure}</span>
				</Text>
			</StyledContentContainer>
		</StyledContainer>
	);
};

export { VehicleProperty };
